window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', 'G-J4M926LXXM');

document.addEventListener('cart:update', function(evt) {
  let form = evt.target;
  if (form.tagName !== 'FORM') {
    form = form.querySelector('form'); // returns first <form> inside
  }
  if (!form) return;

  const formData = new FormData(form);
  const variantId = formData.get('id');
  const quantity = parseInt(formData.get('quantity') || 1);

  // Fetch product info via Ajax API
  fetch(`/variants/${variantId}.js`).then(response => response.json()).then(variant => {
    const data = {
      currency: Shopify.currency.active,
      value: (variant.price / 100) * quantity,
      items: [{
        item_id: variant.id.toString(),
        item_name: variant.name,
        price: variant.price / 100,
        quantity: quantity
      }]
    };
    gtag('event', 'add_to_cart', data);
  });
});

